import { render } from "./BrandValues.vue?vue&type=template&id=67d2d760&scoped=true"
import script from "./BrandValues.vue?vue&type=script&lang=js"
export * from "./BrandValues.vue?vue&type=script&lang=js"

import "./BrandValues.vue?vue&type=style&index=0&id=67d2d760&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d2d760"]])

export default __exports__